import { useContext, useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { toast } from "react-toastify";
import { logo } from '../assets';

const Register = () => {
  const { register } = useContext(AuthContext);
  const [username, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [referralId, setReferralId] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Extract referral ID from URL
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const ref = searchParams.get("ref");
    if (ref) {
      setReferralId(ref);
    }
  }, [location.search]);

  const handleRegister = async (e) => {
    e.preventDefault();
    if (!username || !email || !password) {
      toast.error("All fields are required!");
      return;
    }

    try {
      setLoading(true);
      await register(username, email, password, referralId);
      toast.success("Registration successful!");
      navigate("/");
    } catch (error) {
      toast.error(error.response?.data?.message || "Registration failed!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex max-md:flex-col w-screen h-screen">
      <div className="flex flex-col w-1/2 max-md:w-full h-full max-md:h-[35%] bg-gray-100 justify-center items-center border-r">
        <img src={logo} alt="Thirtify Logo" className="w-24 h-fit rounded-lg object-contain" />
      </div>
      <div className="flex flex-col w-1/2 max-md:w-full h-full max-md:h-[65%] overflow-y-auto scrollbar-hide justify-center items-center">
        <div className="w-full max-w-sm p-6">
          <h2 className="text-2xl font-bold text-center mb-6">Register</h2>
          <form className="flex flex-col gap-4" onSubmit={handleRegister}>
            <input
              type="text"
              placeholder="Name"
              value={username}
              onChange={(e) => setName(e.target.value)}
              className="border border-gray-300 rounded-lg py-2 px-4 focus:outline-none focus:ring-2 focus:ring-rose-500"
              disabled={loading}
              required
            />
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="border border-gray-300 rounded-lg py-2 px-4 focus:outline-none focus:ring-2 focus:ring-rose-500"
              disabled={loading}
              required
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="border border-gray-300 rounded-lg py-2 px-4 focus:outline-none focus:ring-2 focus:ring-rose-500"
              disabled={loading}
              required
            />
            <div className="text-sm text-center">
              Have an account already?
              <Link to="/login" className="text-rose-600 font-bold ml-1">Login</Link>
            </div>
            <button type="submit" className="w-full py-3 bg-rose-600 text-white font-bold rounded-lg hover:bg-rose-700 transition" disabled={loading}>
              {loading ? "Signing Up..." : "Sign Up"}
            </button>
            {referralId && (
              <div className="text-center text-sm text-gray-600">
                Referral Code: <span className="font-bold text-rose-600">{referralId}</span>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Register;